<template>
  <CChartLine
    :datasets="chartData.datasets"
    :labels="chartData.labels"
    :options="chartOptions"
  />
</template>

<script>
import { CChartLine } from '@coreui/vue-chartjs'
import { formatMyr } from '@/utils/money'

export default {
  name: 'PurchaseQuotationTrendChart',
  components: { CChartLine },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += 'RM ' + formatMyr(context.parsed.y);
                }
                return label;
              }
            }
          }
        },
        scales: {
          x: {
            grid: {
              drawOnChartArea: false
            }
          },
          y: {
            beginAtZero: true,
            ticks: {
              callback: function(value) {
                return 'RM ' + Math.round(Number(value) || 0).toLocaleString('en-MY');
              }
            }
          }
        }
      }
    }
  }
}
</script>